import React from "react";
import { Button } from "react-bootstrap";
import { ApproveIcon, CancelIcon, PrintIcon } from "../gui_components/Icons.js";

export class CheckTransactionToolBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: this.props.pageTitle,
      isShowSaveButton: this.props.isShowSaveButton,
      isShowApproveButton: this.props.isShowApproveButton,
      isShowCancelButton: this.props.isShowCancelButton,
      isShowPrintButton: this.props.isShowPrintButton,
      isShowContinueButton: this.props.isShowContinueButton,
    };
  }

  componentDidMount() {
    //
  }

  componentDidUpdate() {
    //
  }

  approveCheckTransaction = (e) => {
    if (e.detail === 1) this.props.approveCheckTransaction();
  };

  cancelCheckTransaction = (e) => {
    if (e.detail === 1) this.props.cancelCheckTransaction();
  };

  printCheckTransaction = (e) => {
    if (e.detail === 1) this.props.printCheckTransaction();
  };

  continueCheckTransaction = (e) => {
    if (e.detail === 1) this.props.continueCheckTransaction();
  };

  render() {
    let pageTitle = this.props.pageTitle;

    return (
      <>
        {this.props.isShowApproveButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.approveCheckTransaction(e)}
          >
            <ApproveIcon />
            Approve
          </Button>
        )}

        {this.props.isShowPrintButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.printCheckTransaction(e)}
          >
            <PrintIcon />
            Print
          </Button>
        )}

        {this.props.isShowRePrintButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.printCheckTransaction(e)}
          >
            <PrintIcon />
            RePrint
          </Button>
        )}

        {this.props.isShowCancelButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.cancelCheckTransaction(e)}
          >
            <CancelIcon />
            Cancel
          </Button>
        )}
        {/*
        {this.props.isShowContinueButton && (
          <Button
            className="header_buttons"
            size="sm"
            onClick={() => this.continueCheckTransaction()}
          >
            Continue
          </Button>
        )} */}
      </>
    );
  }
}

//  const InvoiceModuleToolBar = (props) =>{
//      return(
//         <div>{props.isShowSaveButton}</div>

//      );
//  }
